// redux utils
import {createAsyncThunk} from '@reduxjs/toolkit';
import store from '../store/store'
// api
import * as ppa from './api/ppa'
import {displayErrorMessage, displaySuccessMessage} from '@insticator/insticator-ui'

// thunks
export const uploadBlockListCSV = createAsyncThunk('adServeBlocking/uploadBlockListCSV',
    async (payload, { rejectWithValue }) => {
        const { file } = payload
        try {
            const body = new FormData()
            body.append('file', file)
            const response = await ppa.uploadPolicyViolationCSV({requestData: body})
            store.dispatch(displaySuccessMessage('Upload CSV started successfully'))
            return response.data

        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = 'There was an issue with the upload. Please try again.'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const getBlockListCSV = createAsyncThunk('adServeBlocking/getBlockListCSV',
    async (payload, { rejectWithValue }) => {
        try {
            return await ppa.getPolicyViolationCSV().then(response => response.data)
        } catch(err) {
            return rejectWithValue(err.response.data)
        }
    }
);